<app-header [showHelpButton]="true"></app-header>

<div class="error-page">
  <main class="error-content">
    <div class="error-container">

      <!-- Icon -->
      <div class="error-icon-container">
        <svg class="error-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#737373" stroke-width="1.5"/>
          <line x1="12" y1="7" x2="12" y2="13" stroke="#737373" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="12" cy="16.5" r="0.75" fill="#737373"/>
        </svg>
      </div>

      <!-- Content -->
      <div class="error-text-content">
        <h1 class="error-heading">{{ heading | translate }}</h1>
        <p class="error-body">{{ message | translate }}</p>
        @if (operationId) {
          <p class="error-body">{{ '{' + operationId + '}' }}</p>
        }
      </div>

    </div>
  </main>

  <!-- Footer -->
  <footer class="error-footer">
    <div class="error-footer__container">

      <button class="error-btn-outline" (click)="onTryAgain()">
        {{'web.tryAgain' | translate }}
      </button>

      <button class="error-btn-text" (click)="onContactSupport()">
        <span class="error-btn-text__label">{{ 'web.contactSupport' | translate }}</span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" fill="#236520"/>
        </svg>
      </button>

    </div>
  </footer>

</div>